export const API_BASE_URL = 'https://instant-replay-436813.uc.r.appspot.com/api';

// export const API_BASE_URL = process.env.NODE_ENV === 'production' 
//   ? 'https://instant-replay-436813.uc.r.appspot.com/api'
//   : 'http://127.0.0.1:8000/api';